/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from "formik";
/* import { GlobalAuthContext, GlobalOperationContext } from 'store/context'; */

import DialogComponent from "components/Dialog";
import { Label } from "components/Form";
import { Row, Col } from "components/Grid";
import BrokingSummary from "components/BrokingSummary";
import InputField from "components/Form/InputField";
import Layout from "components/Layout/index";
import SubTitle from "components/SubTitle";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import Button2 from "components/Button2";
import Icon from "components/Icon";
import TagInput from "components/TagInput";
import FileModal from "components/FileModal";

import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { FitinsurAPI ,MessageCenter} from 'utils';

import {
  BoxItems, TextArea
} from "./styles";
import StepNavigation from "components/StepNavigation/index";
import RenderButtons from 'components/RenderButtons';

export default function ApprovedNbi(props) {

  const [file, setFile] = useState();
  const history = useHistory();
  //    const [nbiMessage, setNbiMessage] = useState("");
  const operationContext = useContext(GlobalOperationContext);
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
const mc = new MessageCenter();
  const [summary, setSummary] = useState({});
  const [insurer, setInsurer] = useState([
    {
      company: "AIG",
      items: [
        {
          name: "Adrian Pepper",
          email: "american_international_group_uk_limited@aig.com",
        },
        {
          name: "Andrew Rosindell",
          email: "american_international_group_uk_limited@aig.com",
        },
        {
          name: "Caroline Newton",
          email: "lloyds_company_reinsured_channel_syndicate_2015@channel.com",
        },
        {
          name: "Elliot Colburn",
          email: "american_international_group_uk_limited@aig.com",
        },
      ],
    },
  ]);

  function handleSummary() {
    fitinsur.setAuthToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOjExMDAsInVzZXJuYW1lIjoicG9jX3RleGVsQGZpdGluc3VyLmNvbS5iciIsInBlcnNvbmlkIjoxMDE3MDMsImZpcnN0TmFtZSI6IlRFWEVMIiwibGFzdE5hbWUiOiJGSU5BTkNFIExJTUlURUQiLCJpZFBlcnNvblJvb3QiOjEwMTcwMywidXNlcmFkbWluIjpmYWxzZSwiZXhwIjoxNTk2OTQ0Mjc0LCJpYXQiOjE1OTY1MTIyNzR9.AiO7tVLGrjEzSCfvtAOs9N7mtXEI2e1tozkiS2-1OJ4");
    //fitinsur.setAuthToken(authContext.token); remover linha de cima e descomentar esta 

    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json()).then(data => {
        console.log("Sumario-> ", data.ret_value)
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        /*  setNbiMessage(
             `Dear broker,
As we discussed, please, 
find the attach the NBI related to the deal ${data.ret_value.deal} 
Regards 
${data.ret_value.broker}`); */
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  useEffect(() => {

    handleSummary();

  }, [])

  const client = [
    {
      name: "23 capital",
      contacts: [
        {
          name: "Josivaldo de Jesus",
          email: "josialdo@jesus"
        },
        {
          name: "Josivaldo de Jesus",
          email: "josialdo@jesus"
        },
        {
          name: "Josivaldo de Jesus",
          email: "josialdo@jesus"
        }
      ]
    },
    {
      name: "AIG",
      contacts: [
        {
          name: "Josivaldo de Jesus",
          email: "josialdo@jesus"
        },
        {
          name: "Josivaldo de Jesus",
          email: "josialdo@jesus"
        },
        {
          name: "Josivaldo de Jesus",
          email: "josialdo@jesus"
        }
      ]
    },
    {
      name: "STARR",
      contacts: [
        {
          name: "Josivaldo de Jesus",
          email: "josialdo@jesus"
        },
        {
          name: "Josivaldo de Jesus",
          email: "josialdo@jesus"
        },
        {
          name: "Josivaldo de Jesus",
          email: "josialdo@jesus"
        }
      ]
    }
  ]
  const tag = ["test1ahuehuahuehuaiheuiae", "test2askjdklasjdkljas", "test3ahjsiodjiaosjd"]

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
        <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />
      <BrokingSummary data={summary} />
      <ContentCard title={"APPROVED NBI"} icon  info={{idOperation:props.match?.params?.idOperation || null,idProduct:props.location?.state?.idProduct || null}}  >


        <Label>TO</Label>
        <TagInput
          tags={tag}
        />

        <Formik
          initialValues={{
            CC: "",
            BCC: ""
          }}
          onSubmit={() => {
            console.log("values submetidos")
          }}
        >
          <Form>
            <BoxItems>
              <Col sm={6}>
                <Label>CC</Label>
                <Field
                  style={{ width: "auto" }}
                  name="CC"
                  type="text"
                  component={InputField}
                  placeholder="CC email"
                />
              </Col>

              <Col sm={6}>
                <Label>BCC</Label>
                <Field
                  name="BCC"
                  placeholder="BCC email"
                  component={InputField}
                  type="text"
                />
              </Col>
            </BoxItems>
          </Form>
        </Formik>

        <Label>NBI Request Message</Label>

        <TextArea></TextArea>

        <FileModal idOperation={props?.match?.params?.idOperation} />

        <ButtonContainer>
          <Col md={9}>
            <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
          </Col>
          <RenderButtons idOperation={props.match?.params?.idOperation}>
            <Button
              style={{ marginLeft: "10px" }}
              type="submit"
              primary
              id="btnSubmit"
            >
              SEND NBI REQ
            </Button>
          </RenderButtons>
        </ButtonContainer>
      </ContentCard>
    </Layout>
  );
}